import { render, staticRenderFns } from "./UserCustView.vue?vue&type=template&id=edde0044"
import script from "./UserCustView.vue?vue&type=script&lang=js"
export * from "./UserCustView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports